import Avatar from "../../assets/images/21avatar.jpg";
const BotAvatar = () => {
  return (
    <div
      style={{
        backgroundColor: "#0052cc",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontSize: "22px"
      }}
    >
      <img src={Avatar} alt="21"
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          objectFit: "cover"
        }}
      />
    </div>
  );
};

export default BotAvatar;
